'use client'

import { Cell, Divider, Image, Spacer, Text } from '@vinted/web-ui'
import { Fragment } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { colorCodeToHex } from '@marketplace-web/vendor-abstractions/web-ui-util'
import { DeadlineExtensionOptionItemModel } from '@marketplace-web/conversation-shipping/conversation-shipping-data'

import { truncateString } from '../../../utils/string'

const VISIBLE_THUMBNAILS_LIMIT = 3
const MAX_CHARACTERS = 37

type Props = {
  shipmentItems: Array<DeadlineExtensionOptionItemModel>
  currentShippingDeadline: string
}

const ShipmentItems = ({ shipmentItems, currentShippingDeadline }: Props) => {
  const translate = useTranslate('conversation.extend_shipping_deadline.modal')

  const renderOrderTitle = () => {
    if (shipmentItems.length > 1) {
      const count = shipmentItems.length.toString()

      return <Text as="h2" type="title" text={translate('order_count', { count })} />
    }

    return (
      <Text as="h2" type="title" text={truncateString(shipmentItems[0]!.name, MAX_CHARACTERS)} />
    )
  }

  const renderOrderSubtitle = () => (
    <Text
      as="span"
      text={translate('ship_before', {
        date: currentShippingDeadline,
      })}
    />
  )

  const renderShipmentItem = (item, index) => {
    return (
      <Fragment key={index}>
        <Spacer orientation="horizontal" />
        <Image role="img" src={item.imageUrl} styling="rounded" size="large" scaling="cover" />
      </Fragment>
    )
  }

  const renderOrderPhotos = () => {
    const isRenderingThumbnails = shipmentItems.length > VISIBLE_THUMBNAILS_LIMIT

    return (
      <>
        {isRenderingThumbnails && (
          <Image
            role="img"
            label={`+${shipmentItems.length - VISIBLE_THUMBNAILS_LIMIT}`}
            styling="rounded"
            size="large"
            scaling="cover"
            color={colorCodeToHex('greyscale-level-4')}
          />
        )}
        {shipmentItems.slice(0, VISIBLE_THUMBNAILS_LIMIT).map(renderShipmentItem)}
      </>
    )
  }

  if (!shipmentItems || shipmentItems.length < 1) return null

  return (
    <>
      <Cell title={renderOrderTitle()} body={renderOrderSubtitle()} prefix={renderOrderPhotos()} />
      <Divider />
    </>
  )
}

export default ShipmentItems
